var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area ops-calendar",
      attrs: { id: "page-content-wrapper" }
    },
    [_vm._m(0), _vm._v(" "), _c("app-footer")],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid xyz" }, [
      _c("div", { staticClass: "page-header-top-container" }),
      _vm._v(" "),
      _c("div", { staticClass: "admin-page-content" }, [
        _c("div", { staticClass: "forms-container add_user_forms_container" }, [
          _c("div", { staticClass: "row no-margin" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-sm-12 col-md-12 col-lg-12 b-25 calendar-main-section"
              },
              [
                _c("label", { staticClass: "nopermission" }, [
                  _vm._v("You don't have permission to access this page.")
                ])
              ]
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41613b38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41613b38","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoAccessPermission.vue
// module id = null
// module chunks = 